module.exports = __webpack_public_path__ + "img/white-sox.6431d9b7.svg";